function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { get } from 'lodash';
import { LogoProvider } from './LogoProvider';
import wixVectorIcons from '../../data/wixVectorIcons.json';
import { HttpClient } from '@wix/http-client';
import * as iconSources from './iconSources';
var DEFAULT_SEARCH_OFFSET = 0;
var ICONS_URL_PREFIX = 'https://images-wixmp-fe53c9ff592a4da924211f23.wixmp.com';
export var WixNounProvider = /*#__PURE__*/function (_LogoProvider) {
  _inheritsLoose(WixNounProvider, _LogoProvider);

  function WixNounProvider(webappApi, options) {
    var _this;

    if (options === void 0) {
      options = {};
    }

    _this = _LogoProvider.call(this, iconSources.WIX_NOUN_PROJECT_SOURCE) || this;
    _this.wixLegacyIcons = wixVectorIcons.map(function (icon) {
      return {
        id: icon.id,
        name: icon.name,
        iconUrl: ICONS_URL_PREFIX + icon.url,
        colors: icon.colors,
        source: iconSources.WIX_SOURCE
      };
    });
    _this.options = options;
    _this.webappApi = webappApi;
    _this._httpClient = new HttpClient();
    return _this;
  }

  var _proto = WixNounProvider.prototype;

  _proto.getSVG = /*#__PURE__*/function () {
    var _getSVG = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(icon) {
      var response, iconUrl, source, headers;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              iconUrl = icon.iconUrl, source = icon.source;
              headers = source !== iconSources.WIX_SOURCE && source !== iconSources && source !== iconSources.NEW_WIX_CMS ? {
                'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private'
              } : undefined;
              _context.prev = 2;
              _context.next = 5;
              return this._httpClient.get(iconUrl, {
                // Solves weird bug where sometimes the download fails if it gets from cache
                headers: headers,
                disableWixHeaders: true
              });

            case 5:
              response = _context.sent;
              _context.next = 13;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](2);
              _context.next = 12;
              return this._httpClient.get(iconUrl, {
                disableWixHeaders: true
              });

            case 12:
              response = _context.sent;

            case 13:
              return _context.abrupt("return", response.data);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[2, 8]]);
    }));

    function getSVG(_x) {
      return _getSVG.apply(this, arguments);
    }

    return getSVG;
  }();

  _proto.hasDefault = function hasDefault() {
    return false;
  };

  _proto.translateTerm = /*#__PURE__*/function () {
    var _translateTerm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(term) {
      var _translateTerm2$data$, _translateTerm2$data, mountPoint, url, httpClient, _translateTerm2;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              mountPoint = this.options.basename || window.__BASE_PATH__;
              url = "/api/translateText?q=" + term;
              httpClient = new HttpClient({
                baseURL: mountPoint
              });
              _context2.next = 6;
              return httpClient.get(url);

            case 6:
              _translateTerm2 = _context2.sent;
              return _context2.abrupt("return", (_translateTerm2$data$ = _translateTerm2 == null ? void 0 : (_translateTerm2$data = _translateTerm2.data) == null ? void 0 : _translateTerm2$data.translated) != null ? _translateTerm2$data$ : term);

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", term);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    function translateTerm(_x2) {
      return _translateTerm.apply(this, arguments);
    }

    return translateTerm;
  }();

  _proto._searchIconsByTerm = /*#__PURE__*/function () {
    var _searchIconsByTerm2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(term, offset, sources, skipTranslate) {
      var _this$options$cmsSour, cmsSourceForIcons, filteredTerm, iconsHash, icons, iconsSources, i, source, sourceIcons, _sourceIcons;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (skipTranslate === void 0) {
                skipTranslate = false;
              }

              _this$options$cmsSour = this.options.cmsSourceForIcons, cmsSourceForIcons = _this$options$cmsSour === void 0 ? iconSources.NEW_WIX_CMS : _this$options$cmsSour;
              filteredTerm = term.replace('/', ' ');

              if (skipTranslate) {
                _context3.next = 7;
                break;
              }

              _context3.next = 6;
              return this.translateTerm(filteredTerm);

            case 6:
              filteredTerm = _context3.sent;

            case 7:
              iconsHash = [];
              icons = [];
              iconsSources = {};
              i = 0;

            case 11:
              if (!(i < sources.length)) {
                _context3.next = 30;
                break;
              }

              source = sources[i];

              if (!(source && source === cmsSourceForIcons)) {
                _context3.next = 21;
                break;
              }

              _context3.next = 16;
              return this.webappApi.searchIconBySource(source, filteredTerm, 100, offset);

            case 16:
              iconsHash = _context3.sent;
              sourceIcons = get(iconsHash, 'sourceToSearchOpts', {})[source];
              iconsSources[source] = sourceIcons;
              _context3.next = 27;
              break;

            case 21:
              if (!(source && source === iconSources.NOUN_PROJECT_SOURCE)) {
                _context3.next = 27;
                break;
              }

              _context3.next = 24;
              return this.webappApi.searchIconBySource(source, filteredTerm, 500, offset);

            case 24:
              iconsHash = _context3.sent;
              _sourceIcons = get(iconsHash, 'sourceToSearchOpts', {})[source];
              iconsSources[source] = _sourceIcons;

            case 27:
              i++;
              _context3.next = 11;
              break;

            case 30:
              ;
              sources.forEach(function (key) {
                if (!iconsSources[key]) {
                  iconsSources[key] = [];
                }

                iconsSources[key] = iconsSources[key].map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    source: key
                  });
                });
              });
              sources.forEach(function (key) {
                icons = [].concat(icons, iconsSources[key]);
              });
              return _context3.abrupt("return", {
                icons: icons
              });

            case 34:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function _searchIconsByTerm(_x3, _x4, _x5, _x6) {
      return _searchIconsByTerm2.apply(this, arguments);
    }

    return _searchIconsByTerm;
  }();

  _proto.searchIcons = /*#__PURE__*/function () {
    var _searchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(arrSearchTerms, options) {
      var _this2 = this;

      var _this$options$cmsSour2, cmsSourceForIcons, _options, sources, cleanedArrSearchTerms, searchSources, hasSearchTerms, results, offset, searchPromises, resultsBefore;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (arrSearchTerms === void 0) {
                arrSearchTerms = [];
              }

              if (options === void 0) {
                options = {};
              }

              _this$options$cmsSour2 = this.options.cmsSourceForIcons, cmsSourceForIcons = _this$options$cmsSour2 === void 0 ? iconSources.NEW_WIX_CMS : _this$options$cmsSour2;
              _options = options, sources = _options.sources;
              cleanedArrSearchTerms = arrSearchTerms.filter(function (searchTerm) {
                return !!searchTerm;
              });
              searchSources = sources;

              if (!sources || sources && sources.length === 0) {
                searchSources = [cmsSourceForIcons, iconSources.NOUN_PROJECT_SOURCE];
              }

              hasSearchTerms = cleanedArrSearchTerms && Array.isArray(cleanedArrSearchTerms) && cleanedArrSearchTerms.length && cleanedArrSearchTerms.some(function (term) {
                return term;
              });
              results = [];
              offset =
              /* options.offset || */
              DEFAULT_SEARCH_OFFSET;

              if (options.offset && options.offset >= 100) {
                offset = Math.round(options.offset / 100);
              }

              if (!options.onlyWixLegacyIcons) {
                _context4.next = 13;
                break;
              }

              return _context4.abrupt("return", Promise.resolve(this.getWixLegacyIcons()));

            case 13:
              if (!hasSearchTerms) {
                _context4.next = 20;
                break;
              }

              searchPromises = [];
              cleanedArrSearchTerms.forEach(function (term) {
                searchPromises.push(_this2._searchIconsByTerm(term, offset, searchSources, options.skipTranslate));
              });
              _context4.next = 18;
              return Promise.all(searchPromises);

            case 18:
              resultsBefore = _context4.sent;
              results = resultsBefore.map(function (searchResult) {
                return searchResult.icons;
              }).reduce(function (before, currentSearch) {
                return [].concat(before, currentSearch);
              }, []);

            case 20:
              return _context4.abrupt("return", results);

            case 21:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function searchIcons(_x7, _x8) {
      return _searchIcons.apply(this, arguments);
    }

    return searchIcons;
  }();

  _proto.getWixLegacyIcons = function getWixLegacyIcons() {
    return this.wixLegacyIcons.sort(function (i1, i2) {
      var name1 = parseInt(i1.name) || 10000;
      var name2 = parseInt(i2.name) || 10000;
      return name1 - name2;
    }).map(function (sortedIcon) {
      delete sortedIcon.randomId;
      return sortedIcon;
    });
  };

  _proto.getLegacyWixIconById = function getLegacyWixIconById(id) {
    var icon = this.wixLegacyIcons.find(function (cIcon) {
      return cIcon.id === id;
    });

    if (icon) {
      return icon;
    } else {
      return null;
    }
  };

  _proto.getIconById = function getIconById(id, source) {
    var wixLegacyIcon = this.getLegacyWixIconById(id);

    if (wixLegacyIcon) {
      return Promise.resolve(wixLegacyIcon);
    }

    return this.webappApi.fetchNounAndWixCmsIconById(id, source); // fetch mix icon (wix/npr)
  };

  return WixNounProvider;
}(LogoProvider);